import React from "react";

function RemoveIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 29.25 29.251">
      <g
        id="Groupe_7430"
        data-name="Groupe 7430"
        transform="translate(-815.748 -199.898)"
      >
        <path
          id="Union_62"
          data-name="Union 62"
          d="M20199,4946.626a14.625,14.625,0,1,1,14.625,14.625A14.623,14.623,0,0,1,20199,4946.626Z"
          transform="translate(-19383.254 -4732.103)"
          fill="#fff"
        />
        <path
          id="Icon_ionic-ios-close-circle"
          data-name="Icon ionic-ios-close-circle"
          d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Zm3.705,19.92L18,19.589l-3.705,3.705a1.124,1.124,0,1,1-1.589-1.589L16.411,18l-3.705-3.705a1.124,1.124,0,0,1,1.589-1.589L18,16.411l3.705-3.705a1.124,1.124,0,1,1,1.589,1.589L19.589,18l3.705,3.705a1.129,1.129,0,0,1,0,1.589A1.116,1.116,0,0,1,21.705,23.295Z"
          transform="translate(812.373 196.524)"
          fill="#989898"
        />
      </g>
    </svg>
  );
}

export { RemoveIcon };
